import Modal from "react-bootstrap/Modal";
import { useRef, useState } from "react";
import axiApi from "ApiCaller";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import { SwalAlertClass } from "core/swalClass";

const ModalDeviceMassive = ({ show, setShow, items, setItemsShow }) => {
    const { t: _Tc } = useTranslation("choices");
    const { t: _Tt } = useTranslation("tags");
    const { t: _Tf } = useTranslation("forms");
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const formModalRef = useRef(null);
    const handleClose = () => {
        setShow(false);
    };

    const onSummit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(formModalRef.current);
        const uuids = items.current.chosen;

        const DataSend = {
            status: formData.get("status"),
            uuids: uuids,
        };

        try {
            const resp = await axiApi.post(`/api/devices/massive/`, DataSend);
            if (resp.data.status) {
                items.current.chosen.forEach((uuid) => {
                    const item = items.current.showed.find((item) => item.uuid === uuid);
                    if (item) {
                        item.status = DataSend.status;
                    }
                });
                setItemsShow([...items.current.showed]);
                items.current.reset();
                setShow(false);
                Alert.success(_Tf("labels.success"), _Tf("success.title"));
            } else {
                Alert.error(_Tf("labels.error"));
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
            Alert.error(_Tf("labels.error"));
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="dumpster" />
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">Modificación Masiva</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p className="h5 text-center mb-4">Se han seleccionado {items.current.chosen.length} dispositivos.</p>
                    <form className="ms-auto" ref={formModalRef}>
                        <div className="row d-flex justify-content-center">
                            <div className="col-3 text-end">
                                <label htmlFor="modMass-status" className="col-form-label">
                                    {_Tt("common.status")}
                                </label>
                            </div>
                            <div className="col-9">
                                <Form.Select className="mb-2" id="modMass-status" name="status" style={{ maxWidth: "130px" }}>
                                    <option value="nn">{_Tc("devices.nn")}</option>
                                    <option value="ok">{_Tc("devices.ok")}</option>
                                    <option value="al">{_Tc("devices.al")}</option>
                                    <option value="nc">{_Tc("devices.nc")}</option>
                                    <option value="nf">{_Tc("devices.nf")}</option>
                                    <option value="wk">{_Tc("devices.wk")}</option>
                                    <option value="un">{_Tc("devices.un")}</option>
                                    <option value="re">{_Tc("devices.re")}</option>
                                </Form.Select>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onSummit}>
                        Aceptar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalDeviceMassive;
